import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./ClassInfo.scss";
import { selectIcon, SVG } from "../../components/UI/selector";
import ApiURL from "../../services/ApiURL";
import {
  ActivityInfoApi,
  ScheduleActivityApi,
  accessTokenApi,
  cancelBookedActivity,
} from "../../services/CallApi";
import { DateWithFormat } from "../../components/ReusableComponents/Date/Date";
import {
  CheckValue,
  getClassUserStatus,
  moveToClass,
} from "../../services/CommonFunction";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import { USER_STATUS_IN_ACTIVITY } from "../../Constants/ActivityStatus";
import { profileActions } from "../../store";

const ClassInfo = ({ ...props }) => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { gymIds } = useSelector((state) => state.profile.profileData);
  const [startBtn, setStartBtn] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [isClassLoaded, setIsClassLoaded] = useState(false);
  const [classData, setClassData] = useState({
    name: "--",
    first_name: "-",
    last_name: "-",
    thumb: selectIcon("userDummy"),
    original: selectIcon("userDummy"),
    activity_logo_thumb: selectIcon("defaultClassInfo"),
    activity_logo_original: selectIcon("defaultClassInfo"),
    start_datetime: null,
    gym_id: null,
    gym_name: "--",
    logo_thumb: selectIcon("userDummy"),
    activity_id: null,
    parent_activity_id: null,
    duration_in_minutes: 0,
    start_datetime: null,
    user_status_in_activity: null,
    activity_status: null,
    activity_types: [],
    coach_notes: null,
    description: null,
    private_hint: "--",
    difficulty_level: "--",
    tags: [],
    workout_builder: [],
    equipments_required: [],
    location_name: [],
    playback_url: null,
    ondemand_videos: [],
    leaderboard_type: true,
    heartrate_required: true,
    ended_at: null,
    started_at: null,
    number_of_ondemand_videos_published: "---",
  });
  const isOndemand = !CheckValue(params.parentId);
  const {
    activity_id,
    name,
    activity_logo_original,
    first_name,
    last_name,
    duration_in_minutes,
    gym_name,
    activity_types,
    difficulty_level,
    description,
    coach_notes,
    thumb,
    equipments_required,
    workout_builder,
    location_name,
    start_datetime,
    activity_status,
    user_status_in_activity,
    logo_thumb,
    number_of_ondemand_videos_published,
  } = classData;
  const [classUserStatus, setClassUserStatus] = useState(
    getClassUserStatus(
      isOndemand,
      activity_status,
      user_status_in_activity,
      start_datetime
    )
  );
  useEffect(() => {
    setClassUserStatus(
      getClassUserStatus(
        isOndemand,
        activity_status,
        user_status_in_activity,
        start_datetime
      )
    );
  }, [classData]);

  const bookActivity = () => {
    const data = {
      activity_id: activity_id,
    };
    ScheduleActivityApi(ApiURL._bookScheduledActivity, data).then((res) => {
      if (res.status) {
        setClassUserStatus(
          getClassUserStatus(
            isOndemand,
            activity_status,
            USER_STATUS_IN_ACTIVITY.BOOKED,
            start_datetime
          )
        );
      } else {
        ErrorUI(res.list, () => bookActivity());
      }
    });
  };
  const cancelBooking = () => {
    cancelBookedActivity(activity_id).then((res) => {
      if (res.status) {
        setClassUserStatus(
          getClassUserStatus(false, activity_status, null, start_datetime)
        );
      } else {
        ErrorUI(res.list, () => cancelBooking());
      }
    });
  };
  const handleClick = () => {
    checkUserValidity("userValidate");
  };
  const checkUserValidity = (userValidate) => {
    accessTokenApi().then(async (res) => {
      if (res.status) {
        res.data.gyms.map((gym) => {
          if (gym.gym_id === classData.gym_id) {
            if (gym.linked_status === 1) {
              setStartBtn(true);
              if (userValidate) {
                if (classUserStatus.shouldStartClass) {
                  startOndemand();
                } else if (classUserStatus.shouldBookClass) {
                  bookActivity();
                } else if (classUserStatus.shouldCancelBooking) {
                  cancelBooking();
                }
              }
            } else {
              setStartBtn(false);
              if (userValidate) {
                ErrorUI(
                  "It seems you are not member of this studio.",
                  null,
                  {}
                );
              }
            }
          }
        });
      } else {
        if (res.logout) {
        } else {
          // modalPopup.cross = false;
          //ErrorUI(res.err.response, () => getAccessTokenLoginData());
        }
      }
    });
  };
  useEffect(() => {
    if (gymIds.length) {
      setIsVerified(true);
      getClassInfo(params);
    }
  }, [gymIds]);

  const getClassInfo = (params) => {
    let URL = "";
    const data = {
      limit: 10,
      offset: 0,
      activity_id: params.id,
    };
    if (isOndemand) {
      data["gym_ids"] = JSON.stringify(gymIds);
      URL = ApiURL._ondemandActivityInfo;
    } else {
      /* data["parent_activity_id"] = params.parentId */
      URL = ApiURL._upcomingActivityInfo;
    }
    ActivityInfoApi(URL, data, isOndemand).then((res) => {
      if (res.status) {
        if (
          !isOndemand &&
          res.list.gymLinkStatus !== 1 &&
          res.list.privacy_setting !== "PUBLIC"
        ) {
          ErrorUI(
            "It seems you are not a member of this studio. We have requested studio staff to approve your membership. You can join this workout only if you are an approved member of the studio",
            null,
            {},
            () => {
              history.push("/Studios");
            }
          );
        } else {
          setIsClassLoaded(true);
          setClassData({ ...res.list });
        }
      } else {
        setIsClassLoaded(false);
        ErrorUI(res.list.message, () => getClassInfo(params));
        history.push("/Home");
      }
    });
  };

  const startOndemand = () => {
    const {
      duration_in_minutes,
      heartrate_required,
      workout_builder,
      leaderboard_type,
      gym_id,
      ended_at,
      started_at,
      playback_url,
      ondemand_videos,
      logo_thumb,
      activity_status,
    } = classData;
    const ondemandData = {
      activity_id: params.id,
      duration_in_minutes: duration_in_minutes,
      is_ondemand_workout: true,
      status: "PLAY",
      time_elapsed: 0,
    };
    const workoutData = {
      heartrate_required,
      leaderboard_type,
      workout_builder,
      gym_id,
      ended_at,
      started_at,
      playback_url,
      ondemand_videos,
      logo_thumb,
      activity_id: params.id,
    };
    localStorage.setItem("ondemandData", JSON.stringify(ondemandData));
    localStorage.setItem("workoutData", JSON.stringify(workoutData));
    if (isOndemand) {
      history.push("/Ondemand");
    } else {
      moveToClass(activity_status, history);
    }
  };

  const activityTypes =
    activity_types && activity_types.length
      ? activity_types.map((el, index) => (
          <div
            key={index}
            className="textImageDiv divLightBackground box-layer-forth"
          >
            <p className="boldText">{el}</p>
          </div>
        ))
      : [];

  const equipmentsRequired =
    equipments_required && equipments_required.length
      ? equipments_required
          .filter((el) => el.isRequired)
          .map((el, index) => (
            <div key={index} className="equipmentDetailDiv box-layer2">
              <p>{el.name}</p>
            </div>
          ))
      : [];

  const equipmentsOptional =
    equipments_required && equipments_required.length
      ? equipments_required
          .filter((el) => !el.isRequired)
          .map((el, index) => (
            <div key={index} className="equipmentDetailDiv  box-layer2">
              <p>{el.name}</p>
            </div>
          ))
      : [];

  const segments =
    workout_builder && workout_builder.length
      ? workout_builder.map((el, index) => (
          <div key={index} className="SegmentsDiv box-layer2">
            <div className="SegmentIconDiv">
              <SVG src={selectIcon("manJumping")} />
              {/* <SVG src={activityType1.find(data => data.name === el.segment_icon)['icon']} /> */}
            </div>
            <div className="ColumnDiv">
              <p className="whiteText">{el.segment_name}</p>
              <p className="redText">
                {Math.round(el.segment_duration_in_seconds / 60)} Mins
              </p>
            </div>
          </div>
        ))
      : [];

  const location =
    location_name && location_name.length ? location_name.join() : "--";

  if (isClassLoaded) {
    return (
      <div className="ClassInfo">
        <div className="ClassTitleSection">
          <div className="ClassImage">
            <img src={activity_logo_original} />
          </div>
          <div className="ClassTitleDiv">
            <p className="ClassHeading">{name}</p>
            <div className="ClassDetailRow">
              <div className="textImageDiv">
                <p className="lightText">With {first_name}</p>
              </div>
              <div className="textImageDiv">
                <SVG src={selectIcon("clock")} />
                <p className="lightText">
                  {Math.round(duration_in_minutes)} Mins
                </p>
              </div>
              <div className="textImageDiv">
                <SVG src={selectIcon("watch")} />
                <p className="boldText">
                  <DateWithFormat
                    date={start_datetime}
                    format="MMM D, h:mm A"
                  />
                </p>
              </div>
              {/* <div className="textImageDiv">
              <img src={logo_thumb} />
              <p className="boldText">{gym_name}</p>
            </div> */}
            </div>
            <div className="classExerciseTypeRow">
              {/* ==============ACTIVITY TYPES============ */}
              {activityTypes}
              {/* ======================================== */}
              <div className="textImageDiv">
                <p className="boldText difficultyLevel">
                  {difficulty_level === "BEGINNER" ? (
                    <SVG src={selectIcon("beginner")} />
                  ) : (
                    ""
                  )}
                  {difficulty_level === "INTERMEDIATE" ? (
                    <SVG src={selectIcon("intermediate")} />
                  ) : (
                    ""
                  )}
                  {difficulty_level === "ADVANCED" ? (
                    <SVG src={selectIcon("advanced")} />
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </div>
            <div className="ClassDetailRow">
              {checkUserValidity()}
              {!startBtn ? (
                <button type="button" class="btnDisabled" onClick={handleClick}>
                  {classUserStatus.btnText}
                </button>
              ) : (
                <button type="button" onClick={handleClick}>
                  {classUserStatus.btnText}
                </button>
              )}
            </div>
            <div className="LocationColumn">
              <div className="textImageDiv">
                <p className="boldText">STUDIO LOCATION</p>
              </div>
              <div className="textImageDiv">
                <SVG src={selectIcon("locationPin")} />
                <p className="lightText">{location}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="ClassDescriptionSection">
          <div className="EquipmentsContainer box-layer1">
            <p className="ClassDescriptionBoxTitle">EQUIPMENT</p>
            <p className="EquipmentSubHeading text-h2">REQUIRED EQUIPMENT</p>
            <div className="EquipmentsRow">
              {equipmentsRequired.length ? equipmentsRequired : <p>N/A</p>}
            </div>
            <p className="EquipmentSubHeading text-h2">OPTIONAL EQUIPMENT</p>
            <div className="EquipmentsRow">
              {equipmentsOptional.length ? equipmentsOptional : <p>N/A</p>}
            </div>
          </div>
          <div className="AboutActivityContainer">
            <div className="AboutActivity box-layer1">
              <p className="ClassDescriptionBoxTitle">ABOUT THE ACTIVITY</p>
              {description !== null ? (
                <p className="descriptionText">{description}</p>
              ) : (
                <p className="nullText">N/A</p>
              )}
            </div>
            <div className="CoachNotes">
              <div className="NotesDescriptionDiv box-layer1">
                <p className="ClassDescriptionBoxTitle">COACH NOTES</p>
                {coach_notes !== null ? (
                  <p className="descriptionText">{coach_notes}</p>
                ) : (
                  <p className="nullText">N/A</p>
                )}
              </div>
              <div className="CoachProfileDiv box-layer1">
                <div className="CoachProfileDivFirstRow">
                  <img src={thumb} />
                  <p>
                    {first_name} {last_name}
                  </p>
                </div>
                <div className="CoachProfileDivSecondRow">
                  {isOndemand ? (
                    <div className="CoachProfileDataContainer">
                      <div className="CoachProfileIconAndText">
                        <div className="profileIcons">
                          <SVG src={selectIcon("playIcon1")} />
                        </div>
                        <p>{number_of_ondemand_videos_published}</p>
                      </div>
                      <p>Ondemand</p>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="ClassPreviewContainer box-layer1">
            <p className="ClassDescriptionBoxTitle">CLASS PREVIEW</p>
            <div className="OverViewRow">
              {segments.length ? segments : <p className="nullText">N/A</p>}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ClassInfo;
